import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=af175bac&"
import script from "./allOrders.vue?vue&type=script&lang=js&"
export * from "./allOrders.vue?vue&type=script&lang=js&"
import style0 from "./allOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports